import React, { useEffect, useState } from 'react'
import bgImg from '../assets/images/pattern.svg'
import Search from '../assets/icons/search.svg'
import Filter from '../assets/icons/Filter.svg'
import Faq1 from '../components/faq/Faq1'
import Faq2 from '../components/faq/Faq2'
import Faq3 from '../components/faq/Faq3'
import { PiCheck } from "react-icons/pi";
import { faqs } from '../data/faqData'
import { motion } from 'framer-motion'
import { FiMinus, FiPlus } from 'react-icons/fi'
import Contact from '../components/modals/Contact'
import Modal from '../components/modals/Modal'
import DashboardLayout from './DashboardLayout'




const Help2 = () => {
  const [faq, setFaq] = useState(1)

  const [filter, setFilter] = useState('')
  const [show, setShow] = useState(false)

  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [open, setOpen] = useState(false);


  const [openContact, setOpenContact] = useState(false);


  const filterOptions = ['All', 'Computer-based test FAQ', 'UTME FAQ']

  //   HANDLE FILTER CATEGORY
  const handleFilter = (item) => {
    setFilter(item);
    if (item === 'Computer-based test FAQ') {
      const cbtFaqs = faqs.filter(faq => faq.category === 'cbt');
      setSearchResults(cbtFaqs)
    } else if (item === 'UTME FAQ') {
      const utmeFaqs = faqs.filter(faq => faq.category === 'utme');
      setSearchResults(utmeFaqs)
    }else if (item === 'All') {
      setSearchResults('')
    }
  }


    // FETCH SEARCH RESULTS
  useEffect(() => {
      const filteredResults = faqs.filter((item) => {
        return item.question?.toLowerCase().includes(searchQuery.toLowerCase());
      });
      setSearchResults(filteredResults);
  }, [searchQuery]);



  const handleFaq = (item) => {
    setOpen((prevIndex) => prevIndex === item ? null : item )
  }



  return (
    <DashboardLayout help="Frequently asked questions" childTab={12} animated={true}>
    <div className='flex flex-col items-center justify-center w-full pb-10 lg:pb-12 xl:pb-16'>
         {/*TOP CONTAINER*/}
         <div className='relative flex flex-col items-center justify-center w-full mt-3 px-5 bg-gradient-to-r from-[#15632B] to-[#25A249] h-48 md:px-6 md:h-[155px] lg:h-[170px] 
                         lg:px-7 xl:h-52 xl:px-10'>

            {/* BACKGROUND PATTERN */}
           <div className="absolute top-0 inset-0 w-full h-full bg-left bg-no-repeat" style={{backgroundImage: `url(${bgImg})`}}></div>

           <div className='flex flex-col items-start justify-start w-full'>
               <p className='text-base font-medium text-white md:text-xl lg:text-[22px] xl:text-[28px]'>
                  Generally frequently asked questions
               </p>
               <p className='text-[11px] font-extralight text-white pt-[2px] md:text-xs md:font-light md:pt-1 lg:pt-2 xl:text-base xl:pt-3'>
                  Answers to questions candidates ask
               </p>
           </div>

             
           <div className='flex items-center justify-start flex-wrap w-full md:flex-nowrap md:justify-between md:mt-5 lg:mt-6 xl:mt-7'>
                {/*SEARCH*/}
               <div className='relative h-9 mt-[18px] w-full md:w-[81.5%] md:mt-0 lg:w-[82.5%] xl:h-11 xl:w-[84.5%]'>
                    <input className='border-[1px] rounded-md border-[#DDE1E6] h-full w-full bg-white text-[12px] font-normal pl-9 outline-[#25A249] xl:text-sm xl:pl-12 
                                      xl:rounded-lg' 
                     value={searchQuery}
                     onChange={(e) => setSearchQuery(e.target.value)}
                     placeholder='Search keyword'
                    />
                    <img className='absolute left-3 top-[10px] w-[14px] xl:w-4 xl:top-[14px] xl:left-5' src={Search} alt='search_icon' />
               </div>

               {/*FILTER*/}
               <div onClick={()=>setShow(!show)}
               className={`relative flex items-center justify-center h-8 bg-white mt-5 px-4 text-[12px] font-normal border-[1px] cursor-pointer 
                          rounded-md z-20 hover:border-[#667085] md:mt-0 md:h-9 md:px-6 xl:h-11 xl:text-sm xl:rounded-lg xl:px-7
                          ${filter !== '' ? 'border-[#667085]' : 'border-none' }`}>
                   <img className='w-[10px] md:w-[11px] xl:w-[15px]'
                   src={Filter} alt='filter_icon' />
                   <p className='text-[10px] text-[#667085] font-medium pl-2 md:text-[11px] xl:font-semibold xl:text-sm xl:pl-3'>
                       Filter by
                   </p>

                   {show &&
                   <div className='absolute w-52 top-10 left-0 bg-white border-[1px] border-[#DDE1E6] rounded-md px-3 py-3 pb-4 shadow-xl md:-left-28 md:top-12 md:w-56 md:pb-6 xl:w-72 xl:-left-[150px] xl:top-16'>
                       <p className='text-[10px] text-[#101828] font-medium md:text-[11px] xl:text-sm'>
                          {filter}
                       </p>

                       {filterOptions.map((item) => {
                        return(
                          <div key={item} onClick={()=>handleFilter(item)}
                          className='flex items-center justify-start w-full mt-2 cursor-pointer md:mt-3'>
                              <div className='flex items-center justify-center h-4 w-4 rounded border-[1px] border-[#DDE1E6]'>
                                  {filter === item && <PiCheck />}
                              </div>
                              <p className='text-[10px] text-[#101828] font-medium pl-2 md:text-[11px] xl:text-sm'>
                                 {item}
                              </p>
                          </div>
                        )
                       })}
                   </div>
                   }

               </div>
           </div>

         </div>


         <div className='flex items-start justify-start w-full px-5 mt-6 md:mt-7 md:px-6 lg:px-7 xl:mt-9 xl:px-10'>
             <p className='text-[11px] font-semibold text-[#101828] md:text-xs xl:text-base'>
                 Do you have more questions?
             </p>
             <p onClick={()=>setOpenContact(true)}
             className='text-[11px] font-semibold text-[#25A249] underline pl-1.5 cursor-pointer md:text-xs xl:text-base xl:pl-2'>
                 Contact us
             </p>
         </div>


         {/*SEARCH QUERY RESULTS*/}
        {searchQuery !== '' && (
        <div className='flex items-center justify-between w-full flex-wrap mt-6 px-5 md:justify-start md:px-6 lg:px-7 xl:px-10'>
            {searchResults.length > 0 ? (
              searchResults.map((item) => {
              return(
                  <motion.div
                     initial={{scale: 1, opacity: 0 }}
                     animate={{scale: 1, opacity: [0, 0.1, 0.3, 0.5, 1.0], y:['100%', '0%'] }}
                     transition={{ duration: 0.5, delay: item.id * 0.2, easing: "easeOut", }}
                     key={item.id} 
                     className={`flex flex-col items-start w-full bg-[#F9FAFB] rounded-md border-[1px] cursor-pointer border-[#DDE1E6] px-4 py-3 mb-3 md:py-4 md:px-5 md:mb-4 md:rounded-lg lg:mb-[18px] xl:rounded-xl
                                 xl:py-5 xl:mb-[22px] xl:px-7 ${open && 'py-4 md:py-5'}`}>
                     <div onClick={()=>handleFaq(item.id)}
                     className='flex items-start justify-between w-full'>
                        <p className='text-[10px] font-semibold text-[#101828] w-[85%] md:text-xs xl:text-base'>
                            {item.question}
                        </p>
                        {
                          open === item.id
                          ?<FiMinus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                          :<FiPlus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                        }
                     </div>
  
                     {open === item.id &&
                       <p className='text-[10px] font-normal text-[#5c5453] w-[91%] leading-5 pt-3 md:text-xs md:leading-[22px] md:pt-4 md:w-[95%] lg:text-[12.5px] xl:text-base 
                                     xl:leading-7 xl:pt-5'>
                                     {item.answer}
                       </p>
                     }
                  </motion.div>
                  )
               })):searchResults !== '' &&(
                <div className='flex items-start justify-center w-full h-[50vh]'>
                  <p className='mt-24 font-semibold'>Question not found...</p>
                </div>
              ) 
            }
         </div>
         )}


         {/*FILTER BY CATEGORY RESULTS*/}
        {filter !== '' && filter !== 'All' && (
        <div className='flex items-center justify-between w-full flex-wrap mt-6 px-5 md:justify-start md:px-6 lg:px-7 xl:px-10'>
            {searchResults.length > 0 ? (
              searchResults.map((item) => {
              return(
                  <motion.div
                     initial={{scale: 1, opacity: 0 }}
                     animate={{scale: 1, opacity: [0, 0.1, 0.3, 0.5, 1.0], y:['100%', '0%'] }}
                     transition={{ duration: 0.5, delay: item.id * 0.2, easing: "easeOut", }}
                     key={item.id} 
                     className={`flex flex-col items-start w-full bg-[#F9FAFB] rounded-md border-[1px] cursor-pointer border-[#DDE1E6] px-4 py-3 mb-3 md:py-4 md:px-5 md:mb-4 md:rounded-lg lg:mb-[18px] xl:rounded-xl
                                 xl:py-5 xl:mb-[22px] xl:px-7 ${open && 'py-4 md:py-5'}`}>
                     <div onClick={()=>handleFaq(item.id)}
                     className='flex items-start justify-between w-full'>
                        <p className='text-[10px] font-semibold text-[#101828] w-[85%] md:text-xs xl:text-base'>
                            {item.question}
                        </p>
                        {
                          open === item.id
                          ?<FiMinus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                          :<FiPlus className='text-[#101828] text-base lg:text-lg xl:text-[22px]' />
                        }
                     </div>
  
                     {open === item.id &&
                       <p className='text-[10px] font-normal text-[#5c5453] w-[91%] leading-5 pt-3 md:text-xs md:leading-[22px] md:pt-4 md:w-[95%] lg:text-[12.5px] xl:text-base 
                                     xl:leading-7 xl:pt-5'>
                                     {item.answer}
                       </p>
                     }
                  </motion.div>
                  )
               })):searchResults !== '' &&(
                <div className='flex items-start justify-center w-full h-[50vh]'>
                  <p className='mt-24 font-semibold'>Question not found...</p>
                </div>
              ) 
            }
         </div>
         )}


         {/*FAQ LISTS*/}
         {
          faq === 1 && searchQuery === '' ? <Faq1 setFaq={setFaq} />
         :faq === 2 && searchQuery === '' ? <Faq2 setFaq={setFaq} />
         :faq === 3 && searchQuery === '' && <Faq3 setFaq={setFaq} />
         }


           {/*CONTACT MODALS*/}
        {openContact && (
            <Modal onClick={()=>setOpenContact(false)}>
                 <Contact setModal={setOpenContact} />
            </Modal>
        )}
         
    </div>
    </DashboardLayout>
  )
}

export default Help2
